export default [
	{
		path: "/pros/take-payment",
		exact: true,
		policy: "providerAuth",
		component: "TakePayment",
		mui: true,
	},
];
